<template>
  <div id="app">
    <div class="container">
      <div class="row">
        <div class="col-auto">
          <router-link to="/start"><img class="zhaw-logo" alt="ZHAW Logo" src="./assets/ZHAW_Logo.svg"></router-link>
        </div>
        <div class="col-auto">
          <span class="zhaw-title align-middle">Berater für Weiterbildungen im Bereich Wirtschaftsinformatik</span>
        </div>
      </div>

      <br>

      <div class="row">
        <div class="col">
          <InternetExplorerCheck />
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import InternetExplorerCheck from "./components/helper-components/InternetExplorerCheck";
export default {
  name: 'app',
  components: {InternetExplorerCheck}
}
</script>

<style>
  /* Global styles should probably be used with css/scss imports, and not in this component,
  but it is the easiest and fastest way. */

  #app {
    font-family: Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
  }

  button, a {
     margin: 2px !important;
   }

  .zhaw-logo {
    width: 150px;
    height: 150px;
  }

  .zhaw-title {
    display: inline-block;
    font-size: 30px;
    font-weight: bold;
    color: #1266ac;
  }

  @media only screen and (min-width: 1200px) {
    .zhaw-title {
      margin-top: 50px;
    }
  }

  @media only screen and (max-width: 600px) {
    .zhaw-logo {
      width: 100px;
      height: 100px;
    }

    .zhaw-title {
      font-size: 20px;
    }
  }

  .zhaw-tooltip, .zhaw-icon {
    margin-left: 5px;
    color: #555555;
  }

  .back-button {
    margin-bottom: 10px;
  }

  .btn-primary {
    min-width: 150px;
  }
</style>
